import React, { FC, useEffect } from "react";
import Script from "next/script";
import getConfig from "next/config";
import { useRouter } from "next/router";
import { observer } from "mobx-react";
import { useStore } from "store";
import { setCartData } from "helpers/mindbox";
import { useBreakpoint } from "helpers/hooks";
import { ROUTE_PRODUCT } from "constants/routes";

const { publicRuntimeConfig } = getConfig();

type CreateOptions = {
  endpointId: string;
  firebaseMessagingSenderId?: string | number;
};

const MindBox: FC = () => {
  const { cart, favorites, user } = useStore();
  const endpointId = publicRuntimeConfig.MINDBOX_ENDPOINT_ID;
  const firebaseMessagingSenderId =
    publicRuntimeConfig.MINDBOX_FIREBASE_MESSAGING_SENDER_ID;
  const router = useRouter();
  const breakpoint = useBreakpoint();
  const hideToast =
    breakpoint === "mobile" && router.pathname === ROUTE_PRODUCT;
  const mindbox = function (...rest) {
    mindbox.queue.push(rest);
  };
  mindbox.queue = [];

  if (typeof window !== "undefined" && !window.mindbox) {
    window.mindbox = mindbox;
  }

  useEffect(() => {
    window.getBasket = () =>
      new Promise(resolve => {
        const basket = cart.flattenGroups.map(({ quantity, product }) => ({
          id: product.id,
          priceTypeId: Number(product.priceTypeID),
          quantity,
        }));

        return resolve(basket);
      });
  }, [cart.flattenGroups]);

  useEffect(() => {
    if (endpointId) {
      if (!window.mindboxInitialized) {
        const createTaskOptions: CreateOptions = {
          endpointId,
          firebaseMessagingSenderId,
        };
        window.mindbox("create", createTaskOptions);

        if (firebaseMessagingSenderId) {
          window.mindbox("webpush.create");
          // подписки mindbox
          window.mindbox("webpush.subscribe", {
            getSubscriptionOperation: "GetWebPushSubscription",
            subscribeOperation: "SubscribeToWebpush",
            onGranted: function () {
              console.log("Mindbox Webpush granted");
            },
            onDenied: function () {
              console.log("Mindbox Webpush denied");
            },
          });
        }
      }

      /* todo: remove this when widgets starts using real MindBox api */
      window.addItems = async function (number, productArray) {
        const bitrixProductObject = productArray[0];
        if (bitrixProductObject) {
          const product = {
            id: bitrixProductObject.ID,
            priceTypeID: bitrixProductObject.PRICE_TYPE_ID,
            name: bitrixProductObject.NAME,
            price: bitrixProductObject.PRICE,
          } as Entity.Product;
          await cart.add(
            product,
            { priceTypeID: bitrixProductObject.PRICE_TYPE_ID },
            bitrixProductObject.QUANTITY,
            {
              list: "Виджет рекомендаций",
              position: 0,
            },
            hideToast
          );
        }
      };

      /* todo: remove this when widgets starts using real MindBox api */
      window.rocketToFavorite = (bitrixId, productId) => {
        if (!productId) {
          return null;
        }

        user.withAuth({
          callback: () => {
            favorites.has(productId)
              ? favorites.remove(productId)
              : favorites.add(productId);
          },
          props: {
            onLogin: () => {
              !favorites.has(productId) && favorites.add(productId);
            },
          },
        });
      };
    }
  }, []);

  useEffect(() => {
    if (endpointId) {
      setCartData(cart);
    }
  });

  if (!endpointId) return null;

  return (
    <>
      <Script
        src="https://api.mindbox.ru/scripts/v1/tracker.js"
        strategy="lazyOnload"
      />
      <Script
        src="https://static.popmechanic.ru/service/loader.js?c=7027"
        id="popmechanic-script"
        strategy="lazyOnload"
      />
    </>
  );
};

export default observer(MindBox);
